import { ISelectOption } from "src/app/interfaces/components/select.interface";

export const fiscalEnclosureOptions: ISelectOption[] = [
  { label: 'PEOPLE_FORM.FORM.FISCAL_ENCLOSURE.OPTIONS.NATIONAL_SIMPLE', value: 'NationalSimple' },
  { label: 'PEOPLE_FORM.FORM.FISCAL_ENCLOSURE.OPTIONS.PROFIT_REAL', value: 'ProfitReal' },
  { label: 'PEOPLE_FORM.FORM.FISCAL_ENCLOSURE.OPTIONS.PRESUMED', value: 'Presumed' },
  { label: 'PEOPLE_FORM.FORM.FISCAL_ENCLOSURE.OPTIONS.SIMPLE_EXCESS', value: 'SimpleExcess' },
  { label: 'PEOPLE_FORM.FORM.FISCAL_ENCLOSURE.OPTIONS.MEI', value: 'MEI' },
  { label: 'PEOPLE_FORM.FORM.FISCAL_ENCLOSURE.OPTIONS.PHYSICAL_PERSON', value: 'PhysicalPerson' },
];

export const icmsTaxpayerOptions: ISelectOption[] = [
  { label: 'PEOPLE_FORM.FORM.ICMS_TAXPAYER.OPTIONS.TAXPAYER', value: 'Taxpayer' },
  { label: 'PEOPLE_FORM.FORM.ICMS_TAXPAYER.OPTIONS.EXEMPT_FROM_REGISTRATION', value: 'ExemptFromRegistration' },
  { label: 'PEOPLE_FORM.FORM.ICMS_TAXPAYER.OPTIONS.NON_TAXPAYER', value: 'NonTaxpayer' },
];

export const enterpriseTypeOptions: ISelectOption[] = [
  { label: 'PEOPLE_FORM.FORM.ENTERPRISE_TYPE.OPTIONS.COMPANY', value: 'Manufacturer' },
  { label: 'PEOPLE_FORM.FORM.ENTERPRISE_TYPE.OPTIONS.INDUSTRIAL', value: 'Industry' },
  { label: 'PEOPLE_FORM.FORM.ENTERPRISE_TYPE.OPTIONS.EXPORTER', value: 'Exporter' },
  { label: 'PEOPLE_FORM.FORM.ENTERPRISE_TYPE.OPTIONS.WHOLESALER', value: 'Wholesaler' },
  { label: 'PEOPLE_FORM.FORM.ENTERPRISE_TYPE.OPTIONS.RETAILER', value: 'Retailer' },
  { label: 'PEOPLE_FORM.FORM.ENTERPRISE_TYPE.OPTIONS.SERVICE_PROVIDER', value: 'ServiceProvider' },
  { label: 'PEOPLE_FORM.FORM.ENTERPRISE_TYPE.OPTIONS.COMMERCIAL_REPRESENTATIVE', value: 'CommercialRepresentative' },
  { label: 'PEOPLE_FORM.FORM.ENTERPRISE_TYPE.OPTIONS.CARRIER', value: 'Carrier' },
  { label: 'PEOPLE_FORM.FORM.ENTERPRISE_TYPE.OPTIONS.WAREHOUSE_OPERATOR', value: 'WarehouseOperator' },
  { label: 'PEOPLE_FORM.FORM.ENTERPRISE_TYPE.OPTIONS.IMPORTER', value: 'Importer' },
  { label: 'PEOPLE_FORM.FORM.ENTERPRISE_TYPE.OPTIONS.PHYSICAL_PERSON', value: 'PhysicalPerson' },
];
